import { useState, useEffect } from 'react';
import { debounce } from 'lodash';

export const useDeviceType = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Use debounced resize listener for all devices to:
    // - Reliably detect orientation changes on iPad (screen.orientation doesn't fire reliably)
    // - Filter out rapid resize events during iOS zoom operations
    const handleResize = () => setWidth(window.innerWidth);
    const debouncedHandleResize = debounce(handleResize, 200);

    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);

  return {
    // Based on Carbon Design System's breakpoints
    isMobile: width < 672, // 42rem
    isTablet: width >= 672 && width < 1056, // 66rem
    isDesktop: width >= 1056, // 66rem
    isMobileOrTablet: width < 1056, // 66rem
    isTabletOrDesktop: width >= 672, // 42rem
    width
  };
};
